import React from 'react';
import {StyleSheet} from 'react-native';
import {BackgroundWithGradient} from '../BackgroundWithGradient';

export function TaskInsight() {
  return (
    <BackgroundWithGradient
      description="Prioritize what matters, surface critical tasks, and get instant research on code, docs, and insights—so you can focus on execution"
      heading="Work Smarter with AI-Powered Task Insight!"
      title="Task Insights"
      highlightText="AI-Powered"
      image={require('assets/illustrations/task-insights.png')}
    />
  );
}

const styles = StyleSheet.create({});
